import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpRequestHandler } from '../../models/http-model';
import { HttpService } from '../http.service';
import * as io from 'socket.io-client';
import { Observable } from 'rxjs/Observable';
import * as Rx from 'rxjs/Rx';
const HEADERS = {};

@Injectable()
export class WebsocketService {
    public socket: any;
    static ENV = environment;
    
    constructor() { }

    connect(): Rx.Subject<MessageEvent> {

        // this.socket = io(WebsocketService.ENV.environment.API.websocket, { path: '/status_job/socket.io' });
        if(!this.socket) {
            this.socket = io(WebsocketService.ENV.environment.REPORTS.websocket, { secure: true });
        }
        // We define our observable which will observe any incoming messages
        // from our socket.io server. ***Recibe mensaje
        let observable = new Observable(observer => {
            this.socket.on('message', (data: any) => {
                observer.next(data);
                observer.complete();
            })
            return () => {
                this.socket.disconnect();
                // this.socket.close();
                // this.socket = null;
            }
        });

        let observer = {
            
            next: (data: Object) => {
                this.socket.emit('message', data);
            },
        };

        // we return our Rx.Subject which is a combination
        // of both an observer and observable.
        return Rx.Subject.create(observer, observable);
    }

    public close() {
        this.socket.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/core/services/websocket/websocket.service.ts